import React from 'react';
import { ILinkRow, ITypeRow } from './types';
import { getFormattedText } from '../utils/getFormattedText';
import { LinkRow } from './LinkRow';
import {
    LABEL_COLUM_TYPE,
    RATING_COLUM_TYPE,
    CHIP_COLUM_TYPE,
    AVATAR_COLUM_TYPE,
    USER_STORES_COLUM_TYPE,
    IS_ACTIVE_COLUM_TYPE,
    STRING_ARRAY_COLUM_TYPE,
    ACCESS_LEVEL_COLUM_TYPE,
} from '../constants';
import { LabelRow } from './LabelRow';
import { StringArray } from './StringArray';
import { RatingRow } from './RatingRow';
import { ChipRow } from './ChipRow';
import { AvatarRow } from './AvatarRow';
import { UserStoresRow } from './UserStoresRow';
import { AccessLevelRow } from './AccessLevelRow';
import { IsActiveRow } from './IsActiveRow';
import { useTranslation } from 'react-i18next';

export const TypeRow = ({ column, item }: ITypeRow) => {
    const { t } = useTranslation();

    const { field, type, route, isLink, translation, translationField } =
        column;

    if (translation && translationField)
        return t(translationField.replace('{{field}}', item[field]));

    const text = getFormattedText({ type, field, item, column });

    if (type === RATING_COLUM_TYPE) return <RatingRow row={item} />;
    if (type === STRING_ARRAY_COLUM_TYPE)
        return <StringArray column={column} item={item} />;

    if (type === AVATAR_COLUM_TYPE)
        return <AvatarRow column={column} item={item} />;

    if (type === USER_STORES_COLUM_TYPE)
        return <UserStoresRow column={column} item={item} />;

    if (type === ACCESS_LEVEL_COLUM_TYPE)
        return <AccessLevelRow column={column} item={item} />;

    if (type === IS_ACTIVE_COLUM_TYPE)
        return <IsActiveRow column={column} item={item} />;

    const LINK_ROW_PROPS: ILinkRow = {
        column,
        item,
    };

    if (isLink && route) return <LinkRow {...LINK_ROW_PROPS} />;

    if (Array.isArray(item[field])) {
        return item[field].map((element: string) =>
            translationField ? (
                <p>{t(translationField.replace('{{field}}', element))}</p>
            ) : (
                element
            )
        );
    }

    if (type === LABEL_COLUM_TYPE)
        return <LabelRow column={column} item={item} color={text} />;

    if (type === CHIP_COLUM_TYPE)
        return <ChipRow column={column} item={item} />;

    return text;
};
